import {ConsonantBasic} from "../../../SubjectData/Phonetics/Phonetics.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function ConsonantBasicDeck() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantsNav"}/>
        <FlashcardInterface deckData={ConsonantBasic} title="Basic Consonants" />
     </>
);}
//resource: https://dev.to/gbadeboife/build-a-flashcard-quiz-with-react-49gi